import React, {Component} from 'react';
import ContentWrapper from '../Layout/ContentWrapper';
import {
    Card, CardBody, Button, ButtonGroup, Form, FormGroup, Label, Col, Row,
    Input, UncontrolledButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem, Badge
} from 'reactstrap';
import {Link} from 'react-router-dom';
import {API_ROOT} from '../../api-config';
import Swal from 'sweetalert2'
import moment from 'moment';
import 'moment-timezone';
import {getInvLists, getInvDocuments, saveInvDocument, updateInvDocument, invDocAction} from './InventoryFunctions.js';

const fmt = (v) => {
    const n = parseFloat(v) || 0;
    return (Math.round(n * 100) / 100).toLocaleString('en-CA', {maximumFractionDigits: 2});
};
const num = (v) => parseFloat(v) || 0;

const FORMS = [
    {key: 'PO', name: 'Purchase Order'},
    {key: 'IR', name: 'Item Receipt'},
    {key: 'TO', name: 'Transfer Order'},
    {key: 'TR', name: 'Inventory Transfer'},
    {key: 'AJ', name: 'Inventory Adjustment'},
    {key: 'WO', name: 'Work Order'},
    {key: 'AB', name: 'Assembly Build'},
];

const STATUS_COLOR = {
    'Open': 'secondary', 'In transit': 'info', 'Received': 'success',
    'Partially Received': 'warning', 'Fully Received': 'success',
    'Partially Transferred': 'warning', 'Fully Transferred': 'success',
    'Partially Built': 'warning', 'Fully Built': 'success',
    'Closed': 'dark'
};

class InventoryForms extends Component {
    constructor(props) {
        super(props);
        this.state = {
            active: 'PO',
            lists: {items: [], locations: [], suppliers: [], accounts: [], boms: [], item_types: []},
            docs: [],
            refDocs: {PO: [], TO: [], WO: []},
            form: this.emptyForm('PO'),
            processing: false,
            loading_docs: true,
            editing: null
        };
    }

    componentDidMount() {
        document.title = "Inventory Forms | Jug Beverage Company";
        var self = this;
        getInvLists(function (lists) {
            self.setState({lists: lists});
            self.refreshDocs('PO');
        });
    }

    emptyForm(type) {
        var f = {lines: [{item_id: '', qty: '', rate: '', lot_code: ''}]};
        f.date = moment().format('YYYY-MM-DD');
        if (type === 'TO') f.planned_date = moment().add(7, 'days').format('YYYY-MM-DD');
        if (type === 'PO') {
            f.planned_date = moment().add(14, 'days').format('YYYY-MM-DD');
            f.currency = 'CAD';
        }
        if (type === 'WO') f.planned_date = moment().add(21, 'days').format('YYYY-MM-DD');
        return f;
    }

    stockItems() {
        return this.state.lists.items.filter(i => ['Copack', 'Repack'].indexOf(i.type) === -1);
    }

    locations() {
        return this.state.lists.locations.filter(l => l.is_transit != 1);
    }

    switchForm = (type) => {
        this.setState({active: type, form: this.emptyForm(type), editing: null}, () => this.refreshDocs(type));
    }

    startEdit = (doc) => {
        var f = this.emptyForm(doc.doc_type);
        ['date', 'planned_date', 'planned_arrive', 'inbound_date', 'supplier_id', 'location_id',
            'from_location_id', 'to_location_id', 'carrier', 'bom_id', 'charge_item_id',
            'currency', 'vendor_order_no', 'ship_to', 'related_doc_no', 'comments'].forEach(k => {
            if (doc[k] === undefined || doc[k] === null) return;
            // DATE columns serialize as ISO datetimes — <input type="date"> needs YYYY-MM-DD
            f[k] = (k === 'date' || k.indexOf('_date') !== -1 || k === 'planned_arrive')
                ? moment(doc[k]).format('YYYY-MM-DD') : doc[k];
        });
        if (doc.currency) f.currency = doc.currency;
        if (['PO', 'TO'].indexOf(doc.doc_type) !== -1) {
            f.lines = doc.lines.map(l => ({
                document_line_id: l.document_line_id, item_id: l.item_id, item_code: l.item_code,
                qty: l.qty, rate: l.rate || '', lot_code: l.lot_code || '', done: l.done_qty
            }));
            if (!f.lines.length) f.lines = [{item_id: '', qty: '', rate: ''}];
        } else if (['IR', 'TR'].indexOf(doc.doc_type) !== -1) {
            // event-doc edit: lines carry parent_line_id so the backend can re-post them
            f.lines = doc.lines.map(l => ({
                document_line_id: l.document_line_id, parent_line_id: l.parent_line_id,
                item_id: l.item_id, item_code: l.item_code,
                qty: l.qty, rate: '', lot_code: l.lot_code || ''
            }));
        } else if (doc.doc_type === 'AJ') {
            f.lines = doc.lines.map(l => ({
                item_id: l.item_id, qty: num(l.qty) * (l.sign === -1 ? -1 : 1), lot_code: l.lot_code || ''
            }));
        } else if (doc.doc_type === 'WO') {
            var wl = doc.lines[0] || {};
            f.item_id = wl.item_id; f.qty = wl.qty;
        } else if (doc.doc_type === 'AB') {
            // header-only edit — the related work order is shown but not changeable
            f.related_doc_no = doc.related_doc_no;
            f.compLines = null;
        }
        this.setState({editing: doc, form: f}, () => window.scrollTo(0, 0));
    }

    cancelEdit = () => {
        this.setState({editing: null, form: this.emptyForm(this.state.active)});
    }

    refreshDocs = (type) => {
        var self = this;
        this.setState({loading_docs: true});
        getInvDocuments(type, function (docs) {
            self.setState({docs: docs, loading_docs: false});
        });
        ['PO', 'TO', 'WO'].forEach(function (t) {
            getInvDocuments(t, function (docs) {
                var refDocs = self.state.refDocs;
                refDocs[t] = docs;
                self.setState({refDocs: refDocs});
            });
        });
    }

    setField = (key, value) => {
        var form = this.state.form;
        form[key] = value;
        this.setState({form: form});
        // when linking a plan doc, prefill its lines
        if (key === 'related_doc_no' && value) {
            var type = this.state.active;
            var refType = {IR: 'PO', TR: 'TO', AB: 'WO'}[type];
            var ref = (this.state.refDocs[refType] || []).find(d => d.doc_no === value);
            if (ref && type !== 'AB') {
                form.lines = ref.lines.map(l => ({
                    document_line_id: l.document_line_id, item_id: l.item_id,
                    item_code: l.item_code, ordered: l.qty, done: l.done_qty,
                    qty: Math.max(0, l.qty - l.done_qty)
                }));
                if (type === 'IR') { form.supplier_id = ref.supplier_id; form.location_id = ref.location_id; }
                if (type === 'TR') { form.carrier = ref.carrier; }
                this.setState({form: form});
            }
            if (ref && type === 'AB') {
                var woLine = ref.lines[0] || {};
                var outstanding = Math.max(0, woLine.qty - woLine.done_qty);
                form.qty = outstanding;
                this.setABComponents(ref, outstanding);
            }
        }
    }

    setABComponents = (wo, built) => {
        var form = this.state.form;
        var bom = this.state.lists.boms.find(b => b.bom_id == wo.bom_id);
        form._wo = wo;
        if (bom) {
            form.compLines = bom.lines
                .filter(l => ['Copack', 'Repack'].indexOf(l.item_type) === -1)
                .map(l => ({item_id: l.item_id, item_code: l.item_code,
                    expected: (built * l.qty_per) / (bom.output_qty || 1), qty: '', lot_code: ''}));
        } else {
            form.compLines = [];
        }
        this.setState({form: form});
    }

    setABQty = (val) => {
        var form = this.state.form;
        form.qty = val;
        var bom = this.state.lists.boms.find(b => b.bom_id == (form._wo && form._wo.bom_id));
        if (bom && form.compLines) {
            form.compLines = form.compLines.map(l => ({
                ...l, expected: ((parseFloat(val) || 0) * this.bomQtyPer(l.item_id, bom)) / (bom.output_qty || 1)
            }));
        }
        this.setState({form: form});
    }

    bomQtyPer(item_id, bom) {
        var l = bom.lines.find(x => x.item_id == item_id);
        return l ? l.qty_per : 0;
    }

    setLine = (idx, key, value) => {
        var form = this.state.form;
        form.lines[idx][key] = value;
        this.setState({form: form});
    }

    setCompLine = (idx, key, value) => {
        var form = this.state.form;
        form.compLines[idx][key] = value;
        this.setState({form: form});
    }

    addLine = () => {
        var form = this.state.form;
        form.lines.push({item_id: '', qty: '', rate: '', lot_code: ''});
        this.setState({form: form});
    }

    submit = (e) => {
        e.preventDefault();
        var self = this;
        var type = this.state.active;
        var f = this.state.form;
        var payload = {...f};
        delete payload._wo;
        delete payload.compLines;
        if (type === 'AB') {
            payload.lines = (f.compLines || []).map(l => ({
                item_id: l.item_id, qty: l.qty === '' ? null : l.qty, lot_code: l.lot_code || null}));
        }
        this.setState({processing: true});
        var finish = function (resp) {
            self.setState({processing: false, form: self.emptyForm(type), editing: null}, () => self.refreshDocs(type));
        };
        var onErr = function (msg) {
            Swal("Error", msg, "error");
            self.setState({processing: false});
        };
        if (this.state.editing) {
            if (type === 'AB') {
                // AB has no line repost — send header only
                delete payload.lines;
                delete payload.qty;
            }
            updateInvDocument(this.state.editing.document_id, payload, function (resp) {
                Swal("Updated", resp.doc_no + " updated.", "success");
                finish(resp);
            }, onErr);
            return;
        }
        saveInvDocument(type, payload, function (resp) {
            var msg = {PO: ' No stock has moved — enter an item receipt when it arrives.',
                TO: ' No stock has moved — enter an inventory transfer when it ships.',
                WO: ' No stock has moved — enter an assembly build after the run.'}[type] || '';
            Swal("Saved", resp.doc_no + " saved." + msg, "success");
            self.setState({processing: false, form: self.emptyForm(type)}, () => self.refreshDocs(type));
        }, onErr);
    }

    docAction = (doc, action, extra) => {
        var self = this;
        invDocAction(doc.document_id, action, extra || {}, function () {
            Swal("Done", doc.doc_no + " — " + action + " recorded.", "success");
            self.refreshDocs(self.state.active);
        }, function (msg) {
            Swal("Error", msg, "error");
        });
    }

    arriveDoc = (doc) => {
        var self = this;
        invDocAction(doc.document_id, 'arrive', {inbound_date: moment().format('YYYY-MM-DD')}, function () {
            Swal("Arrived", doc.doc_no + " stock moved into " + (doc.to_name || 'destination') + ".", "success");
            self.refreshDocs(self.state.active);
        }, function (msg) {
            Swal("Error", msg, "error");
        });
    }

    printDoc = (doc) => {
        window.open(API_ROOT + '/inventory/document/' + doc.document_id + '/print', '_blank');
    }

    /* ------------------------------ renders ----------------------------- */

    itemSelect(value, onChange, items) {
        return (
            <Input type="select" value={value || ''} onChange={(e) => onChange(e.target.value)}>
                <option value="">— select item —</option>
                {(items || this.stockItems()).map(i =>
                    <option key={i.item_id} value={i.item_id}>{i.code} ({i.type})</option>)}
            </Input>
        );
    }

    locSelect(value, key) {
        var self = this;
        return (
            <Input type="select" value={value || ''} onChange={(e) => self.setField(key, e.target.value)}>
                <option value="">— select location —</option>
                {self.locations().map(l =>
                    <option key={l.inventory_source_id} value={l.inventory_source_id}>{l.name}</option>)}
            </Input>
        );
    }

    docSelect(value, key, docs, openOnly) {
        var self = this;
        return (
            <Input type="select" value={value || ''} onChange={(e) => self.setField(key, e.target.value)}>
                <option value="">— select document —</option>
                {docs.filter(d => !openOnly || (d.status !== 'Closed' && d.status.indexOf('Fully') !== 0)).map(d =>
                    <option key={d.document_id} value={d.doc_no}>{d.doc_no} — {d.status}</option>)}
            </Input>
        );
    }

    linesEditor(withRate, withLot) {
        var self = this;
        var form = this.state.form;
        var editing = !!this.state.editing;
        return (
            <div>
                <table className="table table-sm">
                    <thead>
                    <tr>
                        <th style={{width: '40%'}}>Item</th>
                        <th style={{width: '15%'}} className="text-right">Qty</th>
                        {withRate ? <th style={{width: '15%'}} className="text-right">Rate</th> : null}
                        {withLot ? <th style={{width: '15%'}}>Lot</th> : null}
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    {form.lines.map((l, i) =>
                        <tr key={i}>
                            <td>{editing && l.item_code ? <span className="small">{l.item_code}{num(l.done) > 0 ? <span className="text-muted"> ({fmt(l.done)} done)</span> : null}</span>
                                : self.itemSelect(l.item_id, (v) => self.setLine(i, 'item_id', v))}</td>
                            <td><Input type="number" className="text-right" value={l.qty}
                                       onChange={(e) => self.setLine(i, 'qty', e.target.value)}/></td>
                            {withRate ?
                                <td><Input type="number" step="0.0001" className="text-right" value={l.rate}
                                           onChange={(e) => self.setLine(i, 'rate', e.target.value)}/></td> : null}
                            {withLot ?
                                <td><Input value={l.lot_code || ''} placeholder="Lot"
                                           onChange={(e) => self.setLine(i, 'lot_code', e.target.value)}/></td> : null}
                            <td><Button size="sm" color="link" onClick={() => {
                                form.lines.splice(i, 1); self.setState({form: form});
                            }}><i className="fas fa-times"></i></Button></td>
                        </tr>)}
                    </tbody>
                </table>
                <Button size="sm" color="default" onClick={this.addLine}>+ Add line</Button>
            </div>
        );
    }

    /* Event-doc edit (IR/TR linked): item is fixed by the parent doc —
       only qty and lot can change. Setting qty to 0 removes the posting. */
    eventLinesEditor() {
        var self = this;
        var form = this.state.form;
        return (
            <div>
                <table className="table table-sm">
                    <thead>
                    <tr>
                        <th>Item</th>
                        <th className="text-right" style={{width: '25%'}}>Qty</th>
                        <th style={{width: '25%'}}>Lot</th>
                    </tr>
                    </thead>
                    <tbody>
                    {form.lines.map((l, i) =>
                        <tr key={i}>
                            <td>{l.item_code}</td>
                            <td><Input type="number" className="text-right" value={l.qty}
                                       onChange={(e) => self.setLine(i, 'qty', e.target.value)}/></td>
                            <td><Input value={l.lot_code || ''} placeholder="Lot"
                                       onChange={(e) => self.setLine(i, 'lot_code', e.target.value)}/></td>
                        </tr>)}
                    </tbody>
                </table>
                <p className="small text-muted">Quantities are re-validated against the linked document and on-hand stock. Set 0 to drop a line.</p>
            </div>
        );
    }

    linkedLinesEditor() {
        var self = this;
        var form = this.state.form;
        var verb = {IR: 'Receiving now', TR: 'Moving now'}[this.state.active];
        return (
            <table className="table table-sm">
                <thead>
                <tr>
                    <th>Item</th>
                    <th className="text-right">Ordered</th>
                    <th className="text-right">Already done</th>
                    <th className="text-right">{verb}</th>
                    <th>Lot</th>
                </tr>
                </thead>
                <tbody>
                {form.lines.map((l, i) =>
                    <tr key={i}>
                        <td>{l.item_code}</td>
                        <td className="text-right">{fmt(l.ordered)}</td>
                        <td className="text-right">{fmt(l.done)}</td>
                        <td style={{width: '140px'}}>
                            <Input type="number" className="text-right" value={l.qty}
                                   onChange={(e) => self.setLine(i, 'qty', e.target.value)}/>
                        </td>
                        <td style={{width: '110px'}}>
                            <Input value={l.lot_code || ''} placeholder="Lot"
                                   onChange={(e) => self.setLine(i, 'lot_code', e.target.value)}/>
                        </td>
                    </tr>)}
                </tbody>
            </table>
        );
    }

    renderForm() {
        var self = this;
        var f = this.state.form;
        var L = this.state.lists;
        var field = (label, input, sm) => (
            <FormGroup row key={label}>
                <Label sm={4} lg={3}>{label}</Label>
                <Col sm={sm || 6}>{input}</Col>
            </FormGroup>
        );
        var dateInput = (key, label) => field(label,
            <Input type="date" value={f[key] || ''} onChange={(e) => self.setField(key, e.target.value)}/>);
        var textInput = (key, label, ph) => field(label,
            <Input value={f[key] || ''} placeholder={ph} onChange={(e) => self.setField(key, e.target.value)}/>);
        var comments = field('Comments',
            <Input type="textarea" value={f.comments || ''} onChange={(e) => self.setField('comments', e.target.value)}/>);
        var supplierSel = (label) => field(label,
            <Input type="select" value={f.supplier_id || ''} onChange={(e) => self.setField('supplier_id', e.target.value)}>
                <option value="">— select supplier —</option>
                {L.suppliers.map(s => <option key={s.supplier_id} value={s.supplier_id}>{s.name}</option>)}
            </Input>);

        var ed = this.state.editing;
        var title = (name, hint) => <h5 key="h">{ed ? 'Edit ' + ed.doc_no : 'New ' + name} <span className="text-muted small">{hint}</span></h5>;
        var editNote = ed ? <p key="en" className="small text-warning ml-1">Editing an existing document — linked receipts/transfers and stock are re-validated on save.</p> : null;

        switch (this.state.active) {
            case 'PO':
                return [title('Purchase Order', '(a plan — moves no stock)'),
                    editNote,
                    supplierSel('Supplier *'),
                    field('Receiving location *', self.locSelect(f.location_id, 'location_id')),
                    dateInput('date', 'Date *'),
                    dateInput('planned_date', 'Planned receipt'),
                    field('Currency',
                        <Input type="select" value={f.currency || 'CAD'} onChange={(e) => self.setField('currency', e.target.value)}>
                            <option value="CAD">CAD</option>
                            <option value="USD">USD</option>
                            <option value="EUR">EUR</option>
                            <option value="GBP">GBP</option>
                        </Input>),
                    textInput('vendor_order_no', 'Vendor sales order #', 'Supplier’s SO#'),
                    field('Ship-to',
                        <Input type="textarea" rows="2" value={f.ship_to || ''} placeholder="Delivery address if different from the receiving location"
                               onChange={(e) => self.setField('ship_to', e.target.value)}/>),
                    comments,
                    field('Lines', this.linesEditor(true), 8)];

            case 'IR':
                return [title('Item Receipt', '(adds stock at the receiving location)'),
                    editNote,
                    field('Purchase order *',
                        ed ? <Input value={ed.related_doc_no || ''} disabled/> :
                            self.docSelect(f.related_doc_no, 'related_doc_no', self.state.refDocs.PO, true)),
                    field('Receiving location *', self.locSelect(f.location_id, 'location_id')),
                    dateInput('date', 'Date received *'),
                    comments,
                    ed ? field('Lines', this.eventLinesEditor(), 8) :
                        (f.related_doc_no ? field('Lines', this.linkedLinesEditor(), 8) : null)];

            case 'TO':
                return [title('Transfer Order', '(a plan — moves no stock)'),
                    editNote,
                    field('From location *', self.locSelect(f.from_location_id, 'from_location_id')),
                    field('To location *', self.locSelect(f.to_location_id, 'to_location_id')),
                    dateInput('date', 'Date *'),
                    dateInput('planned_date', 'Planned ship date *'),
                    dateInput('planned_arrive', 'Planned arrival'),
                    field('Carrier',
                        <Input type="select" value={f.carrier || ''} onChange={(e) => self.setField('carrier', e.target.value)}>
                            <option value="">— select carrier —</option>
                            {L.suppliers.map(s => <option key={s.supplier_id} value={s.name}>{s.name}</option>)}
                        </Input>),
                    comments,
                    field('Lines', this.linesEditor(false, true), 8)];

            case 'TR':
                return [title('Inventory Transfer', '(moves stock now)'),
                    editNote,
                    field('Transfer order',
                        ed ? <Input value={ed.related_doc_no || '(unlinked)'} disabled/> :
                            self.docSelect(f.related_doc_no, 'related_doc_no', self.state.refDocs.TO, true)),
                    ed ? field('Route', <Input value={(ed.from_name || '') + ' \u2192 ' + (ed.to_name || '')} disabled/>) : null,
                    !f.related_doc_no && !ed ? field('From location *', self.locSelect(f.from_location_id, 'from_location_id')) : null,
                    !f.related_doc_no && !ed ? field('To location *', self.locSelect(f.to_location_id, 'to_location_id')) : null,
                    dateInput('date', 'Outbound date *'),
                    field('Inbound date',
                        <Input type="date" value={f.inbound_date || ''} onChange={(e) => self.setField('inbound_date', e.target.value)}/>),
                    <p key="hint" className="small text-muted ml-1">Leave inbound date blank if the arrival date is unknown — the stock will sit at IN TRANSIT until you record its arrival.</p>,
                    comments,
                    ed ? (ed.related_doc_no ? field('Lines', this.eventLinesEditor(), 8) : field('Lines', this.linesEditor(false, true), 8)) :
                        (f.related_doc_no ? field('Lines', this.linkedLinesEditor(), 8) : field('Lines', this.linesEditor(false, true), 8))];

            case 'AJ':
                return [title('Inventory Adjustment', '(fixes stock at one location)'),
                    editNote,
                    field('Location *', self.locSelect(f.location_id, 'location_id')),
                    field('Account *',
                        <Input type="select" value={f.account || ''} onChange={(e) => self.setField('account', e.target.value)}>
                            <option value="">{ed ? '— keep original account —' : '— select reason —'}</option>
                            {L.accounts.map(a => <option key={a.account_id} value={a.name}>
                                {a.name}{a.is_count == 1 ? ' (count only, no financial impact)' : ''}</option>)}
                        </Input>),
                    dateInput('date', 'Date *'),
                    field('Comments *',
                        <Input type="textarea" value={f.comments || ''} onChange={(e) => self.setField('comments', e.target.value)}/>),
                    field('Lines (+ add / − remove)', this.linesEditor(false, true), 8)];

            case 'WO':
                return [title('Work Order', '(a plan — moves no stock)'),
                    editNote,
                    field('Finished good *',
                        ed ? <Input value={(ed.lines[0] || {}).item_code || ''} disabled/> :
                            self.itemSelect(f.item_id, (v) => {
                                self.setField('item_id', v);
                                var bom = L.boms.find(b => b.item_id == v);
                                if (bom) self.setField('bom_id', bom.bom_id);
                            }, L.items.filter(i => i.type === 'Finished Good' || i.type === 'WIP'))),
                    field('Quantity *',
                        <Input type="number" className="text-right" value={f.qty || ''}
                               disabled={!!ed}
                               onChange={(e) => self.setField('qty', e.target.value)} style={{maxWidth: '160px'}}/>),
                    field('Bill of materials *',
                        <Input type="select" value={f.bom_id || ''} onChange={(e) => self.setField('bom_id', e.target.value)}>
                            <option value="">— select BOM —</option>
                            {L.boms.map(b => <option key={b.bom_id} value={b.bom_id}>{b.code} → {b.item_code}</option>)}
                        </Input>),
                    supplierSel('Co-packer *'),
                    field('Location *', self.locSelect(f.location_id, 'location_id')),
                    dateInput('date', 'Date *'),
                    dateInput('planned_date', 'Planned production *'),
                    field('Charge item',
                        self.itemSelect(f.charge_item_id, (v) => self.setField('charge_item_id', v),
                            L.items.filter(i => i.type === 'Copack' || i.type === 'Repack'))),
                    comments];

            case 'AB':
                return [title('Assembly Build', '(consumes components, adds the finished good)'),
                    editNote,
                    field('Work order *',
                        ed ? <Input value={ed.related_doc_no || ''} disabled/> :
                            self.docSelect(f.related_doc_no, 'related_doc_no', self.state.refDocs.WO, true)),
                    dateInput('date', 'Build date *'),
                    f.related_doc_no ? field('Quantity built *',
                        <Input type="number" className="text-right" value={f.qty || ''}
                               disabled={!!ed}
                               onChange={(e) => self.setABQty(e.target.value)} style={{maxWidth: '160px'}}/>) : null,
                    !ed && f.related_doc_no ? textInput('lot_code', 'Lot code (output)', 'Batch / lot # produced') : null,
                    f.compLines && f.compLines.length ? field('Components used',
                        <table className="table table-sm">
                            <thead><tr><th>Item</th><th className="text-right">Expected</th><th className="text-right">Actually used</th><th>Lot</th></tr></thead>
                            <tbody>
                            {f.compLines.map((l, i) =>
                                <tr key={i}>
                                    <td>{l.item_code}</td>
                                    <td className="text-right">{fmt(l.expected)}</td>
                                    <td style={{width: '140px'}}>
                                        <Input type="number" className="text-right" value={l.qty}
                                               placeholder={fmt(l.expected)}
                                               onChange={(e) => self.setCompLine(i, 'qty', e.target.value)}/>
                                    </td>
                                    <td style={{width: '110px'}}>
                                        <Input value={l.lot_code || ''} placeholder="Lot"
                                               onChange={(e) => self.setCompLine(i, 'lot_code', e.target.value)}/>
                                    </td>
                                </tr>)}
                            </tbody>
                        </table>, 8) : null,
                    <p key="hint" className="small text-muted ml-1">Edit what each component actually used — not what the recipe assumed. Blank means the expected amount.</p>,
                    comments];
        }
    }

    renderDocs() {
        var self = this;
        var type = this.state.active;
        var docs = this.state.docs;
        var detail = (d) => {
            if (d.supplier_name) return d.supplier_name;
            if (d.from_name) return d.from_name + ' → ' + (d.to_name || '?');
            return d.location_name || '';
        };
        var qty = (d) => d.lines.map(l => l.item_code + ' × ' + fmt(l.qty)).join(', ');
        return (
            <div className="table-responsive">
                <table className="table table-hover">
                    <thead>
                    <tr>
                        <th>Doc #</th><th>Date</th><th>Details</th><th>Items</th><th>Status</th><th>By</th><th></th>
                    </tr>
                    </thead>
                    <tbody>
                    {docs.map(function (d, i) {
                        var canConfirm = ['PO', 'TO', 'WO'].indexOf(d.doc_type) !== -1 && !d.confirmed && !d.closed;
                        var canClose = ['PO', 'TO', 'WO'].indexOf(d.doc_type) !== -1 && !d.closed;
                        var canPrint = ['PO', 'TO', 'WO'].indexOf(d.doc_type) !== -1;
                        var canArrive = d.doc_type === 'TR' && !d.inbound_date;
                        var canEdit = !d.closed;
                        return (
                            <tr key={i}>
                                <td><b>{d.doc_no}</b>{d.related_doc_no ? <div className="small text-muted">ref {d.related_doc_no}</div> : null}</td>
                                <td>{moment(d.date).format('MMM. D, YYYY')}</td>
                                <td>{detail(d)}</td>
                                <td className="small">{qty(d)}</td>
                                <td><Badge color={STATUS_COLOR[d.status] || 'secondary'}>{d.status}</Badge>
                                    {d.confirmed == 1 ? <Badge color="info" className="ml-1">Confirmed</Badge> : null}</td>
                                <td>{d.staff_first ? d.staff_first + ' ' + (d.staff_last || '').charAt(0) + '.' : ''}</td>
                                <td className="text-right text-nowrap">
                                    {canConfirm ? <Button size="sm" color="success" className="mr-1" onClick={() => self.docAction(d, 'confirm')}>Confirm</Button> : null}
                                    {canClose ? <Button size="sm" color="secondary" className="mr-1" onClick={() => self.docAction(d, 'close')}>Close</Button> : null}
                                    {canPrint ? <Button size="sm" color="default" className="mr-1" onClick={() => self.printDoc(d)}>Print</Button> : null}
                                    {canArrive ? <Button size="sm" color="info" className="mr-1" onClick={() => self.arriveDoc(d)}>Record arrival</Button> : null}
                                    {canEdit ? <Button size="sm" color="warning" onClick={() => self.startEdit(d)}>Edit</Button> : null}
                                </td>
                            </tr>
                        );
                    })}
                    {docs.length === 0 ?
                        <tr><td colSpan="7" className="text-center text-muted">No documents yet.</td></tr> : null}
                    </tbody>
                </table>
            </div>
        );
    }

    render() {
        var self = this;
        return (
            <ContentWrapper>
                <div className="content-heading">
                    <Link to="../inventory">Inventory</Link>&nbsp;/&nbsp;Forms
                </div>
                <div className="text-center mb-3">
                    <ButtonGroup>
                        {FORMS.map(f =>
                            <Button key={f.key} size="sm" color={(this.state.active === f.key ? "info" : "secondary")}
                                    onClick={() => this.switchForm(f.key)}>{f.name}</Button>)}
                    </ButtonGroup>
                </div>
                <Row>
                    <Col lg={6}>
                        <Card className="card-default">
                            <CardBody>
                                <Form onSubmit={this.submit}>
                                    {this.renderForm()}
                                    <FormGroup row>
                                        <Col sm={4} lg={3}></Col>
                                        <Col>
                                            <Button color="primary" type="submit" disabled={this.state.processing}>
                                                <i className={(this.state.processing ? "fa fa-spinner fa-spin mr-2" : "d-none")}></i>
                                                {this.state.editing ? 'Save Changes' : 'Save ' + FORMS.find(f => f.key === this.state.active).name}
                                            </Button>
                                            {this.state.editing ?
                                                <Button color="link" onClick={this.cancelEdit}>Cancel edit</Button> : null}
                                        </Col>
                                    </FormGroup>
                                </Form>
                            </CardBody>
                        </Card>
                    </Col>
                    <Col lg={6}>
                        <Card className={(this.state.loading_docs ? "card card-default whirl traditional" : "card card-default")}>
                            <div className="card-header">
                                <div className="card-title">{FORMS.find(f => f.key === this.state.active).name}s</div>
                            </div>
                            <CardBody>
                                {this.renderDocs()}
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </ContentWrapper>
        );
    }
}

export default InventoryForms;
